import { fetchPortalURL as fetchPortalURLFromTypes } from '@nickeltechnology/types'
export const TRANSACTIONS_URL = '/dashboard/transactions'
// The Resolution Center (docs/chargebacks/design.md §7): the org's disputes.
export const DISPUTES_URL = '/dashboard/transactions/disputes'
export const TRANSACTION_RECEIVABLE =
  '/dashboard/transactions/receivable/:transactionId'
export const TRANSACTION_REFUND =
  '/dashboard/transactions/refund/:transactionId'
export const TRANSACTION_PAYABLE =
  '/dashboard/transactions/payable/:transactionId'
export const TRANSACTION_RETURN =
  '/dashboard/transactions/return/:transactionId'
export const TRANSACTION_VENDOR_RETURN =
  '/dashboard/transactions/vendorReturn/:transactionId'
export const TRANSACTION_CHARGEBACK =
  '/dashboard/transactions/chargeback/:transactionId'
export const TRANSACTION_ADVANCE =
  '/dashboard/transactions/advance/:transactionId'
// :transactionId here is the PaymentActivity id: NB rows are
// activity-anchored (see PaymentActivity.nickelBalanceTransaction).
export const TRANSACTION_NICKEL_BALANCE =
  '/dashboard/transactions/nickelBalance/:transactionId'

export const PAYOUTS_URL = '/dashboard/payouts'
export const VENDOR_PAYOUTS_URL = '/dashboard/vendor-payouts'
export const CHECKOUTS_URL = '/dashboard/payment-links'
export const PAYMENT_LINK_BULK = '/dashboard/payment-links/bulk'
export const GET_PAID_URL = '/dashboard/get-paid'
export const GET_PAID_RECURRING_URL = `${GET_PAID_URL}/recurring`
export const GET_PAID_RECURRING_INVOICE_URL = `${GET_PAID_RECURRING_URL}/:recurringInvoiceId`
export const GET_PAID_RECURRING_INVOICE_QF_URL = `${GET_PAID_RECURRING_INVOICE_URL}/:questionFormId`
export const GET_PAID_RECURRING_INVOICE_CUSTOMER_URL = `${GET_PAID_RECURRING_INVOICE_URL}/customer/:customerId`
export const GET_PAID_CUSTOMERS_URL = '/dashboard/customers'
export const GET_PAID_CUSTOMER_URL = `${GET_PAID_CUSTOMERS_URL}/:customerId`
export const QUESTION_FORM_URL = '/dashboard/get-paid/:questionFormId'
export const NICKEL_PLANS_URL = '/dashboard/settings/plans'
export const CLIENTS_URL = '/dashboard/clients'
export const NEW_CLIENT_URL = '/newclient'
// The old /dashboard/accounts-payable/* URLs are baked into sent emails and
// penny messages, so they permanently redirect (LegacyAccountsPayableRedirect
// in App.tsx).
export const LEGACY_AP_URL = '/dashboard/accounts-payable'
export const PAY_VENDORS_BILLS_URL = '/dashboard/bills'
export const PAY_VENDORS_BILL_URL = `${PAY_VENDORS_BILLS_URL}/:billId`
export const PAY_VENDORS_RECURRING_URL = `${PAY_VENDORS_BILLS_URL}/recurring`
export const PAY_VENDORS_RECURRING_BILL_URL = `${PAY_VENDORS_RECURRING_URL}/:recurringBillId`
export const PAY_VENDORS_RECURRING_BILL_CHILD_URL = `${PAY_VENDORS_RECURRING_BILL_URL}/:billId`

export const BATCH_BILL_PAY_URL = `${PAY_VENDORS_BILLS_URL}/batch-pay`
export const PAY_VENDORS_APPROVALS_URL = '/dashboard/approvals'
export const PAY_VENDORS_APPROVAL_WORKFLOWS_URL =
  '/dashboard/approvals/workflows'
export const PAY_VENDORS_VENDORS_URL = '/dashboard/vendors'
export const PAY_VENDORS_VENDOR_URL = `${PAY_VENDORS_VENDORS_URL}/:vendorId`

/**
 * Addresses merchants type for a page that lives elsewhere, each one seen in
 * the `page_not_found` event (DEV-2824); that event says whether more are
 * worth adding. A `from` must never be a real route, or the alias hides it.
 * App.tsx mounts the `/dashboard/…` ones inside the signed-in layout and the
 * rest at the top level, so a signed-out visitor still reaches /login.
 */
export const URL_ALIASES: ReadonlyArray<{ from: string; to: string }> = [
  { from: '/invoices', to: GET_PAID_URL },
  { from: '/dashboard/invoices', to: GET_PAID_URL },
  { from: '/settings', to: '/dashboard/settings' },
  { from: '/bills', to: PAY_VENDORS_BILLS_URL },
  { from: '/dashboard/bill-pay', to: PAY_VENDORS_BILLS_URL },
  { from: '/transactions', to: TRANSACTIONS_URL },
  { from: '/payments', to: TRANSACTIONS_URL },
  { from: '/dashboard/payments', to: TRANSACTIONS_URL },
]
export const REGISTRATION_SELF_SERVE_URL = '/register'
export const REFERRALS_URL = '/dashboard/referrals'
export const ADMIN_URL = '/dashboard/admin'
export const ADMIN_BECOME_USER_URL = `${ADMIN_URL}/become-user`
export const ADMIN_BALANCE_URL = `${ADMIN_URL}/balance`
export const ADMIN_PENNY_CHATS_URL = `${ADMIN_URL}/penny-chats`
export const ADMIN_PARTNERS_URL = `${ADMIN_URL}/partners`
export const ADMIN_PARTNER_SLUG = `${ADMIN_PARTNERS_URL}/:partnerId`
export const adminPartnerUrl = (partnerId: string) =>
  `${ADMIN_PARTNERS_URL}/${encodeURIComponent(partnerId)}`
export const ADMIN_ORGANIZATION_SLUG = `${ADMIN_URL}/:organizationId`

export const BATCH_AUTO_DEBIT_URL = `/dashboard/batch-payment`
export const BATCH_REQUEST_CUSTOMER_AUTH_URL = `${GET_PAID_CUSTOMERS_URL}/batch-request-authorization`
export const BATCH_SEND_AGING_REPORT_URL = `${GET_PAID_CUSTOMERS_URL}/batch-send-aging-report`
export const BATCH_REQUEST_VENDOR_DETAILS_URL = `${PAY_VENDORS_VENDORS_URL}/batch-request-delivery-details`
export const ONBOARDING_TEST_URL = `${ADMIN_URL}/onboarding-test`
export const RFI_TEST_URL = `${ADMIN_URL}/rfi-test`
export const GET_STARTED_URL = '/dashboard/get-started'
export const NICKEL_BALANCE_URL = '/dashboard/nickel-banking'
export const NICKEL_BALANCE_CHECK_DEPOSITS_URL = `${NICKEL_BALANCE_URL}/check-deposits`
export const NICKEL_BALANCE_NEW_CHECK_DEPOSIT_URL = `${NICKEL_BALANCE_CHECK_DEPOSITS_URL}/new`

export const OAUTH_AUTHORIZE_URL = '/oauth/authorize'

export const PENNY_CHATS_URL = '/dashboard/penny/chats'
export const AGENT_APPROVALS_URL = '/dashboard/agent-approvals'
export const AGENT_APPROVAL_URL = `${AGENT_APPROVALS_URL}/:approvalId`
export const PENNY_CHAT_NEW_URL = `${PENNY_CHATS_URL}/new`
export const PENNY_CONNECTORS_URL = '/dashboard/penny/connectors'
export const PENNY_CONNECTOR_URL = `${PENNY_CONNECTORS_URL}/:connectionId`

export const NICKEL_BALANCE_CARDS_URL = `${NICKEL_BALANCE_URL}/cards`
export const NICKEL_BALANCE_NEW_CARD_URL = `${NICKEL_BALANCE_CARDS_URL}/new`
export const NICKEL_BALANCE_CARD_DETAIL_URL = `${NICKEL_BALANCE_CARDS_URL}/:id`
export const nickelBalanceCardUrl = (cardId: string) =>
  `${NICKEL_BALANCE_CARDS_URL}/${cardId}`

// The product's old prefix, baked into sent emails, Penny replies and
// bookmarks, so App.tsx redirects it permanently
// (LegacyNickelBalanceRedirect). Never drop it.
export const LEGACY_NICKEL_BALANCE_URL = '/dashboard/nickel-balance'

const MOVED_LEGACY_SUB_PATHS: ReadonlyArray<[legacy: string, current: string]> =
  [['/virtual-cards', NICKEL_BALANCE_CARDS_URL]]

export function currentNickelBalancePath(pathname: string): string {
  const rest = pathname.slice(LEGACY_NICKEL_BALANCE_URL.length)
  for (const [legacy, current] of MOVED_LEGACY_SUB_PATHS) {
    if (rest === legacy || rest.startsWith(`${legacy}/`)) {
      return `${current}${rest.slice(legacy.length)}`
    }
  }
  return `${NICKEL_BALANCE_URL}${rest}`
}

export function isNickelBalancePath(pathname: string): boolean {
  return (
    pathname.startsWith(NICKEL_BALANCE_URL) ||
    pathname.startsWith(LEGACY_NICKEL_BALANCE_URL)
  )
}

export const NICKEL_BALANCE_TRANSACTION_URL = `${NICKEL_BALANCE_URL}/transactions/:activityId`

export const NICKEL_BALANCE_TRANSFER_URL = `${NICKEL_BALANCE_URL}/transfer`
export const NICKEL_BALANCE_STATEMENTS_URL = `${NICKEL_BALANCE_URL}/statements`
export const NICKEL_BALANCE_INSTRUCTIONS_URL = `${NICKEL_BALANCE_URL}/instructions`
export const NICKEL_BALANCE_LINKED_ACCOUNTS_URL = `${NICKEL_BALANCE_URL}/linked-accounts`
export const NICKEL_BALANCE_APPLICATION_URL = `${NICKEL_BALANCE_URL}/apply`

export const NICKEL_BALANCE_ACCOUNTS_URL = `${NICKEL_BALANCE_URL}/accounts`
export const NICKEL_BALANCE_NEW_ACCOUNT_URL = `${NICKEL_BALANCE_ACCOUNTS_URL}/new`
export const NICKEL_BALANCE_ACCOUNT_DETAIL_URL = `${NICKEL_BALANCE_ACCOUNTS_URL}/:accountId`
export const NICKEL_BALANCE_ACCOUNT_TRANSACTION_URL = `${NICKEL_BALANCE_ACCOUNT_DETAIL_URL}/transactions/:activityId`
export const nickelBalanceAccountUrl = (accountId: string) =>
  `${NICKEL_BALANCE_ACCOUNTS_URL}/${accountId}`

export const fetchPortalURL = (
  subdomain: string = 'nickel',
  customDomain?: string,
) => {
  const isDevelopment = import.meta.env.MODE === 'development'
  const isStaging = import.meta.env.VITE_SENTRY_ENVIRONMENT === 'staging'

  return fetchPortalURLFromTypes(
    isDevelopment,
    isStaging,
    subdomain,
    customDomain,
  )
}

export const fetchDashboardURL = () => {
  if (import.meta.env.MODE === 'development') {
    return 'http://localhost:3000'
  } else if (import.meta.env.VITE_SENTRY_ENVIRONMENT === 'staging') {
    return 'https://app.staging.nickel.com'
  } else {
    return 'https://app.nickel.com'
  }
}

export const getFrameOrigin = (): string => {
  if (import.meta.env.VITE_FRAME_ORIGIN) {
    return import.meta.env.VITE_FRAME_ORIGIN
  }
  if (import.meta.env.MODE === 'development') {
    return 'http://localhost:3002'
  }
  if (import.meta.env.VITE_SENTRY_ENVIRONMENT === 'staging') {
    return 'https://f.staging.nickelpayments.com'
  }
  return 'https://f.nickelpayments.com'
}

export const SETTINGS_NOTIFICATIONS_URL = '/dashboard/settings/notifications'
// The base URL is an Administrator's Team Notifications tab (everyone else's
// Your Notifications; docs/workspace-roles/notifications.md §14), and these
// are the Administrator's other views. Each bounces to the base URL for a
// non-Administrator.
export const SETTINGS_YOUR_NOTIFICATIONS_URL = `${SETTINGS_NOTIFICATIONS_URL}/yours`
export const SETTINGS_NOTIFICATION_SETTINGS_URL = `${SETTINGS_NOTIFICATIONS_URL}/settings`
export const SETTINGS_EXTERNAL_USERS_URL = `${SETTINGS_NOTIFICATIONS_URL}/external-users`
export const SETTINGS_MEMBERS_URL = '/dashboard/settings/members'
export const SETTINGS_BILL_PAY_URL = '/dashboard/settings/accounts-payable'
export const SETTINGS_ROLES_URL = '/dashboard/settings/roles'
export const SETTINGS_NEW_ROLE_URL = `${SETTINGS_ROLES_URL}/new`
export const SETTINGS_ROLE_URL = `${SETTINGS_ROLES_URL}/:roleId`
export const settingsRoleUrl = (roleId: string) =>
  `${SETTINGS_ROLES_URL}/${roleId}`
export const settingsRoleGroupUrl = (roleId: string, group: string) =>
  `${settingsRoleUrl(roleId)}?group=${group}`
export const SETTINGS_CLIENT_ACCESS_URL = '/dashboard/settings/client-access'
export const clientAccessUrl = (clientId?: string | null) =>
  clientId
    ? `${SETTINGS_CLIENT_ACCESS_URL}?client=${encodeURIComponent(clientId)}`
    : SETTINGS_CLIENT_ACCESS_URL
